module.exports = __webpack_public_path__ + "assets/img/banner.d1bbb7c6.jpg";